import axios from "axios";

export const API = process.env.REACT_APP_API_URL || "https://api.leaderbored.gg/api";

const axiosInstance = axios.create({
  baseURL: API,
  // baseURL: "https://leaderbored-api.taktylstudios.com/api",
  // headers: {
  //   'Cache-Control': 'public, max-age=31536000',
  //   'Accept-Encoding': 'gzip, deflate, br'
  // }
  // maxContentLength: 100 * 1024 * 1024,
  // maxBodyLength: 100 * 1024 * 1024,
});

export default axiosInstance;
